import { ReservationOccasion } from '../../../../../services/exports/Constants';

export default {
  updated_details: 'Opdaterede oplysninger',
  previous_details: 'Tidligere oplysninger',
  fields: {
    datetime: 'Dato:',
    email: 'E-mail:',
    phone_number: 'Telefonnummer:',
    customer: 'Kunde:',
    source: 'Kilde:',
    guests: 'Gæster:',
    comment: 'Kommentar:',
    confirmed_at: 'Bekræftet den:',
    status: 'Status:',
    occasion: 'Anledning:',
    created_at: 'Oprettet den:',
  },
  status: {
    confirmed: 'Bekræftet',
    pending: 'Afventer godkendelse',
    canceled: 'Annulleret',
    canceled_by_customer: 'Annulleret af kunden',
    rejected: 'Afvist',
    removed: 'Fjernet',
  },
  buttons: {
    confirm: 'Bekræft',
    reject: 'Afvis',
    cancel: 'Annuller',
    edit: 'Rediger',
    remove: 'Fjern',
  },
  occasion: {
    [ReservationOccasion.Birthday]: 'Fødselsdag',
    [ReservationOccasion.Anniversary]: 'Jubilæum',
    [ReservationOccasion.Date]: 'Date',
    [ReservationOccasion.SpecialOccasion]: 'Særlig lejlighed',
    [ReservationOccasion.BusinessMeal]: 'Forretningsmiddag',
  },
  remove_reservation_modal: {
    title: 'Er du sikker på, at du vil fjerne reservationen?',
    buttons: {
      remove: 'Fjern',
      cancel: 'Annuller',
    },
  },
  response_messages: {
    success: 'Reservationsstatus er opdateret. Kunden er blevet underrettet.',
    error: 'Opdatering af reservationsstatus mislykkedes. Prøv igen.',
  },
};
